require('./bootstrap');

$(document).ready(function() {
    $('.register_target_selection a[data-toggle="tab"]').on('shown.bs.tab', function (event) {
        let target_id = $(event.target).attr('id');
        $('input[name=target]').val(target_id);

        let enabled = '#other-selection';
        let disabled = '#myself-selection';

        if (target_id == 'myself') {
            enabled = '#myself-selection';
            disabled = '#other-selection';
        }

        $(enabled).find('.mandatory').prop('required', true);
        $(disabled).find('.mandatory').prop('required', false);
        $(disabled).find('input').val('');
    });
});
